// group ids for security groups from microsoft graph.

export enum UserPermission {
    SchedulingOrderMgmt = 'b20ee30c-1eb0-43c6-ada6-728adfe7e7c9',
    UNAUTHORIZED = 'none',
}

export const QUORUM_TENANT = '47eb93f9-3c37-419c-ae4e-37c50e7d1dc0';

export function userPermissionFromGroupId(groupId: string) {
    if (Object.values(UserPermission).includes(groupId as UserPermission)) {
        return groupId as UserPermission
    }
    return null;
}